module.exports = __webpack_public_path__ + "img/4_2_1.a9778b5d.jpg";